import install from '@/utils/installComponents'

const components = {}

export default {
  ...components,
  install: install(components),
}
